import { LOCALE } from '@digital-dealer/environments';

import { deliveryFeeConfigMap } from './configs';

const configOverride = {
  leasing: {
    modules: {
      modelViewer: {
        checkout: {
          totalPriceForPeriod: {
            deliveryFee: deliveryFeeConfigMap[LOCALE],
          },
        },
      },
    },
  },
};

export default configOverride;

